import React from "react";
import SIdebar from "./SIdebar";
import innerlogo from "../assets/svgs/innerlogo.svg";

const Container = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="h-[100vh] w-[100vw] grid grid-cols-[10%_90%] font-poppins">
      <SIdebar />
      <div className="bg-bg-blue ml-[-3%] [border-radius:35px_0_0_35px] relative ">
        <div className="flex items-center pl-16 pt-2 absolute">
          <img src={innerlogo} alt="innerlogo" />
        </div>
        <div className=" w-[85vw] mx-auto mt-[60px] h-[87vh]">
            {children}
        </div>
      </div>
    </div>
  );
};

export default Container;
